import { useRef, useEffect, useState } from 'react';
import Item from './Item';
import Loader from '../../../components/Loader';

const Sheets = ({ data }) => {
    const checkLineRef = useRef(null);
    const [pages, setPages] = useState([]);
    const [checkScales, setCheckScales] = useState([]);

    useEffect(() => {
        if (checkScales.length !== data.length) return;
    
        const columns = data.flatMap((_, i) => {
            const count = checkScales[i];
            return Array.from({ length: count }, (_, j) => ({
                checkIndex: i,
                partIndex: j,
                totalParts: count,
            }));
        });
    
        const columnsPerPage = 3;
        const totalPages = Math.ceil(columns.length / columnsPerPage);
        const result = Array.from({ length: totalPages }, (_, pageIndex) => {
            return columns.slice(pageIndex * columnsPerPage, (pageIndex + 1) * columnsPerPage);
        });
    
        setPages(result);
    }, [checkScales, data]);

    const handleScaleCalculated = (scale) => {
        setCheckScales((prevScales) => [...prevScales, scale]);
    };

    return (
        <>
            {pages && pages.length > 0 ? (
                <div className="list-pages-container" id="printable-area">
                    {pages.map((pageCols, pageIndex) => (
                        <div key={pageIndex} className="list-page">
                            <div className="list-content-wrapper">
                                {pageCols.map(({ checkIndex, partIndex, totalParts }) => {
                                    const widthPercent = 100 / totalParts;
                                    return (
                                        <div key={`${checkIndex}-${partIndex}`} className="list-page-col">
                                            <Item
                                                translateX={`${-100 * partIndex}%`}
                                                width={`${widthPercent}%`}
                                                part={`${partIndex + 1}/${totalParts}`}
                                                checkIndex={checkIndex}
                                                {...data[checkIndex]}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <>
                    <Loader/>
                    <div className="list-check-line" ref={checkLineRef}>
                        {data.map((item, index) => (
                            <Item 
                                key={index}
                                checkIndex={index}
                                {...item}
                                onScaleCalculated={(scale) => {handleScaleCalculated(scale)}}
                            />
                        ))}
                    </div>
                </>
            )}
        </>
    );
};

export default Sheets;


